import { render, staticRenderFns } from "./Ketoasidoz.vue?vue&type=template&id=276d5047&"
import script from "./Ketoasidoz.vue?vue&type=script&lang=js&"
export * from "./Ketoasidoz.vue?vue&type=script&lang=js&"
import style0 from "./Ketoasidoz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports